import { render, staticRenderFns } from "./DoudianProductSelectorFilters.vue?vue&type=template&id=3cb74f5d&scoped=true"
import script from "./DoudianProductSelectorFilters.vue?vue&type=script&lang=js"
export * from "./DoudianProductSelectorFilters.vue?vue&type=script&lang=js"
import style0 from "./DoudianProductSelectorFilters.vue?vue&type=style&index=0&id=3cb74f5d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb74f5d",
  null
  
)

export default component.exports